import fetchJsonp from 'fetch-jsonp'
import serialize from 'form-serialize'
import Cookies from 'js-cookie'
import { SHOP_URL } from '@js/lib/constants'

// Example Use:
// <div x-data="addtocartsimple('SKU')" x-bind="submit" class=""></div>

export default (sku = null) => ({
  form: '',
  sku: sku,
  shopDomain: SHOP_URL,

  submit: {
    ['@submit.prevent.stop'](ev) {
      this.processAddToCart(ev)
    },
  },

  async init() {
    if (!this.sku) {
      return false
    }

    const url = new URL(`${this.shopDomain}/index.cfm`)
    url.searchParams.append('method', 'remote.addToCartForm')
    url.searchParams.append('productSKU', this.sku)

    await fetchJsonp(url.href, {
      jsonpCallback: '?callback',
      timeout: 7000,
    })
      .then((response) => response.json())
      .then((html) => {
        let wdWrapper = document.createElement('div')
        wdWrapper.innerHTML = html.trim()

        const forms = wdWrapper.querySelectorAll('form')
        
        for (let i = 0; i < forms.length; i++) {
          if (i > 0) {
            forms[i].remove()
          }
        }

        this.form = wdWrapper
      })

    this.$el.innerHTML = this.form.outerHTML
  },

  processAddToCart(ev) {
    const form = ev.target
    const formAction = form.action.split('?method=')[1]

    let serializedForm = serialize(form, { empty: true, hash: false })
    let d = new Date()

    const url = new URL(`${this.shopDomain}/index.cfm`)
    url.searchParams.append('method', formAction)
    url.searchParams.append('modalLayout', 1)
    url.searchParams.append('timeStamp', d.getTime())
    url.searchParams.append('remoteOrderID', this.getOrderID())
    url.searchParams.append('thirdPartyCookiesSupported', false)

    fetchJsonp(`${url.href}&${serializedForm}`, {
      jsonpCallback: '?callback',
    })
      .then((response) => response.json())
      .then((resp) => {
        // Wine direct can return json or html, depending on the thirdPartyCookiesSupported param
        try {
          const json = JSON.parse(resp)
          this.$dispatch('cart-item-added', json)
        } catch (err) {
          // This "error" is really just that resp is not JSON but html
          this.$dispatch('cart-item-added', {
            content: resp,
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })

    if (
      typeof window.dataLayer !== 'undefined' &&
      typeof window.dataLayer.push !== 'undefined' &&
      this.winedata
    ) {
      let formObj = serialize(form[0], { hash: true })

      // add quantity to wine data
      this.winedata.ecommerce.add.products[0].quantity = formObj.Quantity
      window.dataLayer.push(this.winedata)
    }
  },

  getOrderID() {
    if (Cookies.get('ORDERID')) {
      return Cookies.get('ORDERID')
    }

    return ''
    // This will look for the order ID in the url
    // const params = new Proxy(new URLSearchParams(window.location.search), {
    //   get: (searchParams, prop) => searchParams.get(prop),
    // });
    // return params.remoteOrderID;
  },
})
